import { CircularProgress, FormControlLabel, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomizedDialogs from "../../atoms/modal/customizedDialogs";
import Search from "../../molecules/search";
import Checkboxcomponent from "../../atoms/checkBox";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { TreeItem, TreeView } from "@mui/x-tree-view";
import Button from "@mui/material/Button";
import { Stack } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import { LoadingButton } from "@mui/lab";
import {
    getSchemaSelectionSelector,
    getPendingSelector,
    getErrorSelector,
} from "../../../store/schemaSelection/selectors";
import { fetchSchemaSelectionRequest } from "../../../store/schemaSelection/actions";
import { useDispatch, useSelector } from "react-redux";
import {
    ISchemaSelection,
} from "../../../store/schemaSelection/types";
import { postDataSelector } from "../../../store/dataSource/selectors";
import { useNavigate } from "react-router-dom";
import { IDataSourceFields } from '../../organisms/dataSourceForm/index'
import { IUser } from '../../../store/groups/types';

interface INestedSchemaType {
    name: string;
    tableInfo: ITableType[];
}

interface ITableType {
    name: string;
    type: string;
}

interface ISchemaSelectionProps {
    disableSchemaBtn?: boolean;
    dataSourceData: IDataSourceFields;
    accessControlGroup: string[];
    dataStewardGroup: string;
    dataStewardIDs: IUser[];
    endpoint: string;
    mode?: string;
    sourceID?: string;
    spokeName?: string;

    //isTableModalOpen: boolean;
    //onSchemaModelClose: () => void;
    //schemaData: INestedSchemaType[];
}

const SchemaSelection = (props: ISchemaSelectionProps) => {
    const dispatch = useDispatch();
    const pending = useSelector(getPendingSelector);
    const schemaData = useSelector(getSchemaSelectionSelector);
    const error = useSelector(getErrorSelector);

    const dataSource = useSelector(postDataSelector);

    const [selectedSchemaNames, setSelectedSchemaNames] = useState<
        Array<INestedSchemaType>
    >([]);
    const [searchValue, setSearchValue] = useState("");
    const [selectedTable, setSelectedTable] = useState<Array<string>>([]);
    const [tableList, setTableList] = useState<Array<string>>([]);

    const [firstOpenModel, setFirstOpenModel] = useState<boolean>(false);
    const [secondOpenModel, setSecondOpenModel] = useState<boolean>(false);
    const [nestedSchema, setNestedSchema] = useState<INestedSchemaType[]>([]);
    const navigate = useNavigate();

    useEffect(() => {
        if (dataSource !== null && props.mode === "Add") {
            const id: any = dataSource?.sourceId;
            dispatch(fetchSchemaSelectionRequest(id));
        }

    }, [dataSource]);

    useEffect(() => {

        if (props.sourceID && props.mode === "View") {
            const id = props.sourceID;
            dispatch(fetchSchemaSelectionRequest(Number(id)));
        }

    }, [props.sourceID]);

    const openDialog = () => {
        setFirstOpenModel(true);
        const schemaNameList: string[] = [];
        var tableList: ITableType[] = [];
        const mainObject: INestedSchemaType[] = [];

        if (schemaData.length > 0) {
            const nestedSchemaList = schemaData.map(
                (schema: ISchemaSelection): INestedSchemaType[] => {
                if (schemaNameList.includes(schema.schema)) {
                    var temp = mainObject.find((x) => x.name === schema.schema);
                    temp?.tableInfo.push({ name: schema.name, type: schema.type });
                } else {
                    schemaNameList.push(schema.schema);
                    tableList = [];
                    tableList.push({
                        name: schema.name,
                        type: schema.type,
                    });
                    mainObject.push({
                        name: schema.schema,
                        tableInfo: tableList,
                    });
                }


                return mainObject;

            }
            );

            setNestedSchema(nestedSchemaList[0]);
        }
    };

    //Schema Checkbox Selection
    const schemaSelectionEvent = (event: React.ChangeEvent<HTMLInputElement>) => {
        const selectedSchema =
            nestedSchema.find((x) => x.name === event.target.name) ?? undefined;
        if (event.target.checked === true) {
            const schemaList = [...selectedSchemaNames];
            if (selectedSchema !== undefined) {
                schemaList.push(selectedSchema);
                setSelectedSchemaNames(schemaList);
            }
        } else {
            const schemaNames = selectedSchemaNames.filter(
                (x) => x !== selectedSchema
            );
            setSelectedSchemaNames(schemaNames);
        }
    };

    //Table Checkbox Selection
    const tableSelectionEvent = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked === true) {
            if (event.target.name !== undefined) {
                const tableList = [...selectedTable];
                tableList.push(event.target.name);
                setSelectedTable(tableList);
            }
        } else {
            const tables = selectedTable.filter((x) => x !== event.target.name);
            setSelectedTable(tables);
        }
    };

    const renderSchemaTree = (nodes: INestedSchemaType) => (
        <TreeItem key={nodes.name} nodeId={nodes.name} label={nodes.name}>
            {nodes.tableInfo.map((table, index) => <div key={index}>{renderTables(table)}</div>)}
        </TreeItem>
    );

    const renderTables = (tables: ITableType) => (
        <>
            <TreeItem
                key={tables.name}
                nodeId={tables.name}
                label={
                    <FormControlLabel
                        control={
                            <Checkboxcomponent
                                label=""
                                name={tables.name}
                                checked={selectedTable.includes(tables.name) ? true : false}
                                onChange={tableSelectionEvent}
                            />
                        }
                        label={<>{tables.name}</>}
                        key={tables.name}
                    />
                }
            />
        </>
    );

    const searchTables = (event: React.ChangeEvent<HTMLInputElement>) => {
        console.log(" Search Value : " + event.target.value);

        let searchVal = event.target.value;
        const tables: string[] = [];

        if (searchVal && searchVal !== "") {
            setSearchValue(searchVal);

            selectedSchemaNames.map((schema) =>
                schema.tableInfo.map((item) => tables.push(item.name))
            );

            setTableList(tables);
        } else {
            setSearchValue(searchVal);
            setTableList(tables);
        }
    };

    const openNextModal = (type: string) => {
        if (type === "configTables") {
            // console.log(selectedSchemaNames)
            navigate("/ConfigureTables", {
                state: {
                    selectedTables: selectedTable, selectedSchema: selectedSchemaNames, dataSourceData: props.dataSourceData,
                    accessControlGroup: props.accessControlGroup, dataStewardGroup: props.dataStewardGroup, endpoint: props.endpoint,
                    dataStewardIDs: props.dataStewardIDs, dataSourceName: dataSource?.sourceName, spokeName: props.spokeName
                }
            });
        } else if (type === "openTable") {
            setFirstOpenModel(false);
            setSecondOpenModel(true);
        } // openSchema
        else {
            setFirstOpenModel(true);
            setSecondOpenModel(false);
        }
    };



    const closeModal = () => {
        setFirstOpenModel(false);
        setSecondOpenModel(false);
        // removes all selected values
        setSelectedSchemaNames([]);
        setSelectedTable([]);
        setTableList([]);
    };

    return (
        <>

            {pending ? <LoadingButton
                loading
                variant="outlined"
                size="small"
                sx={{ mr: 2 }}
                loadingPosition="start"
                startIcon={<SaveIcon />}
            >
                Loading Schemas
                        </LoadingButton>
                : <Button id="2d361543-12c0-4ac7-b26b-8b323963c6db"
                    color="primary"
                    variant="contained"
                    disabled={props.disableSchemaBtn}
                    onClick={openDialog}
                    style={{ marginRight: '1em' }}
                >
                    Select Schemas
            </Button>
            }
            <CustomizedDialogs
                dialogHeight='600px'
                modalSize="lg"
                key="schema"
                modalTitle="Select Schema"
                isOpen={firstOpenModel}
                onClose={closeModal}
                footerAction={
                    <Stack direction="row" spacing={2}>
                        <Button id="39ae0a3b-4c53-435a-b93e-ea4b92830df5" color="primary" variant="contained" onClick={closeModal}>
                            Close
                        </Button>
                        <Button id="14513207-63a4-46a8-9e63-b04747c4654b"
                            color="primary"
                            variant="contained"
                            // disabled={schemaData.length < 1}
                            onClick={() => openNextModal("openTable")}
                            disabled={selectedSchemaNames.length === 0}
                        >
                            Next
                        </Button>

                    </Stack>
                }
            >
                <>
                    <strong className="normal">
                        You can start searching the Schema Name by typing below:
                    </strong>
                    <Search
                        value={searchValue}
                        changeEvent={(e) => setSearchValue(e.target.value)}
                    />
                    <br />
                    <strong className="normal">Select the Schemas below</strong>
                    <div>
                        {pending ? (
                            <CircularProgress />
                        ) : error ? (
                            <div>Error</div>
                        ) : (
                            <Grid container spacing={1}>
                                {nestedSchema
                                    .filter((item) => {
                                        if (!searchValue) return true;
                                        if (item.name.toLowerCase().includes(searchValue.toLowerCase())) {
                                            return true;
                                        }
                                        return false;
                                    })
                                    .map((item, index) => (
                                        <Grid key={index} item xs={6}>
                                            <Checkboxcomponent
                                                key={item.name}
                                                name={item.name}
                                                label={item.name}
                                                checked={
                                                    selectedSchemaNames.includes(item) ? true : false
                                                }
                                                onChange={schemaSelectionEvent}
                                            ></Checkboxcomponent>
                                        </Grid>
                                    ))}
                            </Grid>
                        )}
                    </div>
                </>
                <br />
            </CustomizedDialogs>

            <CustomizedDialogs
                dialogHeight='600px'
                modalSize="lg"
                key="table"
                modalTitle="Select Table"
                isOpen={secondOpenModel}
                onClose={() => false}
                footerAction={
                    <Stack direction="row" spacing={2}>
                        <Button id="8f302f71-5020-4f3c-a973-76a86b061c77"
                            color="primary"
                            variant="contained"
                            onClick={() => openNextModal("openSchema")}
                        >
                            Back
                        </Button>
                        <Button id="ebe65011-c536-4737-9392-a91d71805673"
                            color="primary"
                            variant="contained"
                            onClick={() => openNextModal("configTables")}
                            disabled={selectedTable.length === 0}
                        >
                            Create Extractors
                        </Button>
                    </Stack>
                }
            >
                <>
                    <strong className="normal">
                        You can start searching the Table Name by typing below:
                    </strong>
                    <Search value={searchValue} changeEvent={searchTables} />
                    <br />
                    <strong className="normal">Select the Table names below</strong>

                    {searchValue !== "" ? (
                        <Grid container spacing={1}>
                            {tableList
                                .filter((item) => {
                                    if (!searchValue) return true;
                                    if (item.toLowerCase().includes(searchValue.toLowerCase())) {
                                        return true;
                                    }
                                    return false;
                                })
                                .map((item) => (
                                    <Grid key={item} item xs={6}>
                                        <Checkboxcomponent
                                            key={item}
                                            name={item}
                                            label={item}
                                            checked={selectedTable.includes(item) ? true : false}
                                            onChange={tableSelectionEvent}
                                        ></Checkboxcomponent>
                                    </Grid>
                                ))}
                        </Grid>
                    ) : (
                        <TreeView
                            defaultCollapseIcon={<ExpandMoreIcon />}
                            defaultExpanded={["0", "3", "4"]}
                            defaultExpandIcon={<ChevronRightIcon />}
                        >
                            <>
                                {selectedSchemaNames.map((singleSchema) =>
                                    renderSchemaTree(singleSchema)
                                )}
                            </>
                        </TreeView>
                    )}
                </>
                <br />
            </CustomizedDialogs>
        </>
    );
};

export default SchemaSelection;
